import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "className", "summaryClassName", "label", "children", "size", "onLabelClick", "closeIcon", "openIcon", "closeRotate", "openRotate", "iconClassName", "initialIsOpen"];
import React, { forwardRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { Text } from "../Text";
import styles from "./styles.pcss";
import { contentVariantMap, labelVariantMap } from "./utils";
import { AccordionIcon } from "./AccordionIcon";
import { useAccordion } from "./hooks/useAccordion";
var cnAccordion = cnBem('accordion', styles);
export var Accordion = /*#__PURE__*/forwardRef(function (props, ref) {
  var isOpenProp = props.isOpen,
    className = props.className,
    summaryClassName = props.summaryClassName,
    label = props.label,
    children = props.children,
    _props$size = props.size,
    size = _props$size === void 0 ? 'l' : _props$size,
    onLabelClick = props.onLabelClick,
    closeIcon = props.closeIcon,
    openIcon = props.openIcon,
    closeRotate = props.closeRotate,
    openRotate = props.openRotate,
    iconClassName = props.iconClassName,
    initialIsOpen = props.initialIsOpen,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useAccordion = useAccordion({
      isOpen: isOpenProp,
      onLabelClick: onLabelClick,
      initialIsOpen: initialIsOpen
    }),
    isOpen = _useAccordion.isOpen,
    detailsRef = _useAccordion.detailsRef,
    contentRef = _useAccordion.contentRef,
    summaryRef = _useAccordion.summaryRef,
    onClick = _useAccordion.onClick,
    actualOpen = _useAccordion.actualOpen;
  return /*#__PURE__*/React.createElement("details", _extends({
    className: cnAccordion({
      isOpen: actualOpen,
      size: size
    }, [className]),
    open: isOpen,
    ref: combineRefs([ref, detailsRef])
  }, otherProps, {
    "data-t-id": "components-Accordion"
  }), /*#__PURE__*/React.createElement("summary", {
    "aria-label": "".concat(isOpen ? 'Скрыть' : 'Показать', " \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435"),
    className: cnAccordion('top', summaryClassName),
    onClick: onClick,
    ref: summaryRef
  }, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    variant: labelVariantMap[size]
  }, label), /*#__PURE__*/React.createElement(AccordionIcon, {
    className: cnAccordion('icon', [typeof iconClassName === 'function' ? iconClassName(isOpen) : iconClassName]),
    closeIcon: closeIcon,
    closeRotate: closeRotate,
    isOpen: actualOpen,
    openIcon: openIcon,
    openRotate: openRotate
  })), /*#__PURE__*/React.createElement(Text, {
    className: cnAccordion('content'),
    color: "tertiary",
    ref: contentRef,
    tagName: "div",
    variant: contentVariantMap[size]
  }, children));
});